import React from 'react';

export default function MenuSplitter() {
  return (
    <span className="divider" aria-hidden="true">
      |
    </span>
  );
}
